var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-flex flex-column align-stretch"},[_c('theHeading')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }